import {DashboardRoute} from "./routes/Dashboard.js";
const routes = [DashboardRoute];
export default routes;
